import type { ReturnMethodInfo } from 'shipping-and-returns/types/ReturnsInfoContext.types'

export const getMethodInfoByReturnType = (
	returnMethods: ReturnMethodInfo[],
	types: string[][]
) =>
	types.map((type) => returnMethods.find((method) => type.includes(method.id)))
